<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="cta-stage">
        <div class="cta-banner">
          <span class="cta-bar cta-bar--title"></span>
          <span class="cta-bar cta-bar--sub"></span>
          <span class="cta-button">
            <span class="cta-button-bar"></span>
          </span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="cta-phone-q"></span>
      <span class="cta-phone-bar"></span>
      <button
        type="button"
        class="cta-phone-btn"
        tabindex="-1"
      >
        <span class="cta-phone-btn-bar"></span>
      </button>
      <span class="cta-phone-confirm">
        <span class="cta-phone-tick" aria-hidden="true">
          <svg viewBox="0 0 16 16" width="10" height="10">
            <path
              d="M3 8.5l3 3 7-7"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span class="cta-phone-confirm-bar"></span>
      </span>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewCtaBanner',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.cta-stage {
  flex: 1;
  display: grid;
  place-items: center;
  min-height: 150px;
  padding: 8px;
}
.cta-banner {
  width: 100%;
  background: color-mix(in srgb, var(--accent) 10%, white);
  border: 1.5px solid color-mix(in srgb, var(--accent) 40%, transparent);
  border-radius: 10px;
  padding: 18px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
}
.cta-bar {
  display: block;
  height: 10px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.22);
}
.cta-bar--title { width: 60%; height: 13px; }
.cta-bar--sub { width: 40%; height: 7px; background: rgba(15, 15, 20, 0.14); }
.cta-button {
  margin-top: 6px;
  display: grid;
  place-items: center;
  background: var(--accent);
  border-radius: 999px;
  padding: 7px 18px;
  min-width: 80px;
  animation: cta-pulse 4s ease-in-out infinite;
}
.cta-button-bar {
  display: block;
  height: 7px;
  width: 50px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 999px;
}

/* ---- Audience phone ---- */
.cta-phone-q {
  display: block;
  height: 8px;
  width: 70%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
}
.cta-phone-bar {
  display: block;
  height: 6px;
  width: 50%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.cta-phone-btn {
  appearance: none;
  margin-top: 6px;
  display: grid;
  place-items: center;
  background: var(--accent);
  border: none;
  border-radius: 999px;
  padding: 10px 16px;
  cursor: pointer;
  position: relative;
  animation: cta-tap 4s ease-in-out infinite;
}
.cta-phone-btn-bar {
  display: block;
  height: 7px;
  width: 60px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 999px;
}
.cta-phone-confirm {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 6px;
  background: color-mix(in srgb, var(--accent) 10%, white);
  opacity: 0;
  animation: cta-confirm 4s ease-in-out infinite;
}
.cta-phone-tick {
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background: var(--accent);
  color: white;
  display: grid;
  place-items: center;
}
.cta-phone-confirm-bar {
  display: block;
  height: 6px;
  width: 60px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
}

@keyframes cta-pulse {
  0%, 18%   { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 35%, transparent); }
  35%       { box-shadow: 0 0 0 8px color-mix(in srgb, var(--accent) 0%, transparent); }
  100%      { box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 0%, transparent); }
}
@keyframes cta-tap {
  0%, 18%   { transform: scale(1); box-shadow: 0 0 0 0 color-mix(in srgb, var(--accent) 35%, transparent); }
  22%       { transform: scale(0.94); box-shadow: 0 0 0 6px color-mix(in srgb, var(--accent) 20%, transparent); }
  35%       { transform: scale(1); box-shadow: 0 0 0 10px color-mix(in srgb, var(--accent) 0%, transparent); }
  100%      { transform: scale(1); }
}
@keyframes cta-confirm {
  0%, 30%   { opacity: 0; transform: translateY(2px); }
  40%, 90%  { opacity: 1; transform: translateY(0); }
  100%      { opacity: 0; transform: translateY(2px); }
}

@media (prefers-reduced-motion: reduce) {
  .cta-button, .cta-phone-btn { animation: none; }
  .cta-phone-confirm { animation: none; opacity: 1; }
}
</style>
